import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function BackButton({ fallbackPath = '/', label = 'Back', className = '' }) {
  const navigate = useNavigate();

  function handleBack() {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate(fallbackPath);
    }
  }

  return (
    <button
      type="button"
      onClick={handleBack}
      className={`as-back-btn ${className}`}
      aria-label="Go back to previous page"
      data-testid="back-button"
    >
      <ArrowLeft size={15} />
      <span>{label}</span>
    </button>
  );
}
